import { render, staticRenderFns } from "./ProductMaskOverlay.vue?vue&type=template&id=6fb39678&scoped=true&"
import script from "./ProductMaskOverlay.vue?vue&type=script&lang=js&"
export * from "./ProductMaskOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProductMaskOverlay.vue?vue&type=style&index=0&id=6fb39678&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb39678",
  null
  
)

export default component.exports